import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { getAllCountries, getAllCountryNames, isLoaded } from './countries.selectors';

@Injectable()
export class CountriesFacade {
  private readonly store = inject(Store);

  loaded$ = this.store.pipe(select(isLoaded));
  /**
   * @description
   * Loads a list of countries and their localized names
   * according to the list of countries currently incorporated
   * in the ISO 3166-1 code list.
   * @see https://en.wikipedia.org/wiki/ISO_3166-1#Codes
   * @see [Country](./countries.models.ts)
   * @see {@link allCountryNames$}
   */
  allCountries$ = this.store.pipe(select(getAllCountries));
  /**
   * @description
   * Loads a list of localized country names
   * according to the list of countries currently incorporated
   * in the ISO 3166-1 code list.
   * @see https://en.wikipedia.org/wiki/ISO_3166-1#Codes
   * @see {@link allCountries$}
   */
  allCountryNames$ = this.store.pipe(select(getAllCountryNames));
}
